import { __decorate } from 'tslib';
import * as i1 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgClass, NgStyle } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, booleanAttribute, Directive, Input, Output, Component, ChangeDetectionStrategy, ViewEncapsulation, NgModule } from '@angular/core';
import { zoomBigMotion } from 'ng-zorro-antd/core/animation';
import { WithConfig } from 'ng-zorro-antd/core/config';
import { NzNoAnimationDirective } from 'ng-zorro-antd/core/no-animation';
import * as i3 from 'ng-zorro-antd/core/outlet';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import * as i2 from 'ng-zorro-antd/core/overlay';
import { NzOverlayModule } from 'ng-zorro-antd/core/overlay';
import { NzTooltipBaseDirective, NzToolTipComponent, isTooltipEmpty } from 'ng-zorro-antd/tooltip';
function NzPopoverComponent_ng_template_0_Conditional_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.nzTitle);
  }
}
function NzPopoverComponent_ng_template_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, NzPopoverComponent_ng_template_0_Conditional_6_ng_container_1_Template, 2, 1, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r1.nzTitle);
  }
}
function NzPopoverComponent_ng_template_0_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.nzContent);
  }
}
function NzPopoverComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4);
    i0.ɵɵelement(3, "span", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 6)(5, "div");
    i0.ɵɵtemplate(6, NzPopoverComponent_ng_template_0_Conditional_6_Template, 2, 1, "div", 7);
    i0.ɵɵelementStart(7, "div", 8);
    i0.ɵɵtemplate(8, NzPopoverComponent_ng_template_0_ng_container_8_Template, 2, 1, "ng-container", 9);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("ant-popover-rtl", ctx_r1.dir === "rtl");
    i0.ɵɵproperty("ngClass", ctx_r1._classMap)("ngStyle", ctx_r1.nzOverlayStyle)("@.disabled", !!(ctx_r1.noAnimation == null ? null : ctx_r1.noAnimation.nzNoAnimation))("nzNoAnimation", ctx_r1.noAnimation == null ? null : ctx_r1.noAnimation.nzNoAnimation)("@zoomBigMotion", "active");
    i0.ɵɵadvance(6);
    i0.ɵɵconditional(ctx_r1.nzTitle ? 6 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r1.nzContent);
  }
}
const NZ_CONFIG_MODULE_NAME = 'popover';
let NzPopoverDirective = /*#__PURE__*/(() => {
  class NzPopoverDirective extends NzTooltipBaseDirective {
    getProxyPropertyMap() {
      return {
        nzPopoverBackdrop: ['nzBackdrop', () => this.nzPopoverBackdrop],
        ...super.getProxyPropertyMap()
      };
    }
    constructor() {
      super(NzPopoverComponent);
      this._nzModuleName = NZ_CONFIG_MODULE_NAME;
      this.trigger = 'hover';
      this.placement = 'top';
      this.nzPopoverBackdrop = false;
      // eslint-disable-next-line @angular-eslint/no-output-rename
      this.visibleChange = new EventEmitter();
    }
    static {
      this.ɵfac = function NzPopoverDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzPopoverDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NzPopoverDirective,
        selectors: [["", "nz-popover", ""]],
        hostVars: 2,
        hostBindings: function NzPopoverDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ant-popover-open", ctx.visible);
          }
        },
        inputs: {
          arrowPointAtCenter: [2, "nzPopoverArrowPointAtCenter", "arrowPointAtCenter", booleanAttribute],
          title: [0, "nzPopoverTitle", "title"],
          content: [0, "nzPopoverContent", "content"],
          directiveTitle: [0, "nz-popover", "directiveTitle"],
          trigger: [0, "nzPopoverTrigger", "trigger"],
          placement: [0, "nzPopoverPlacement", "placement"],
          origin: [0, "nzPopoverOrigin", "origin"],
          visible: [0, "nzPopoverVisible", "visible"],
          mouseEnterDelay: [0, "nzPopoverMouseEnterDelay", "mouseEnterDelay"],
          mouseLeaveDelay: [0, "nzPopoverMouseLeaveDelay", "mouseLeaveDelay"],
          overlayClassName: [0, "nzPopoverOverlayClassName", "overlayClassName"],
          overlayStyle: [0, "nzPopoverOverlayStyle", "overlayStyle"],
          nzPopoverBackdrop: "nzPopoverBackdrop"
        },
        outputs: {
          visibleChange: "nzPopoverVisibleChange"
        },
        exportAs: ["nzPopover"],
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  __decorate([WithConfig()], NzPopoverDirective.prototype, "nzPopoverBackdrop", void 0);
  return NzPopoverDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NzPopoverComponent = /*#__PURE__*/(() => {
  class NzPopoverComponent extends NzToolTipComponent {
    constructor() {
      super(...arguments);
      this._prefix = 'ant-popover';
    }
    get hasBackdrop() {
      return this.nzTrigger === 'click' ? this.nzBackdrop : false;
    }
    isEmpty() {
      return isTooltipEmpty(this.nzTitle) && isTooltipEmpty(this.nzContent);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵNzPopoverComponent_BaseFactory;
        return function NzPopoverComponent_Factory(__ngFactoryType__) {
          return (ɵNzPopoverComponent_BaseFactory || (ɵNzPopoverComponent_BaseFactory = i0.ɵɵgetInheritedFactory(NzPopoverComponent)))(__ngFactoryType__ || NzPopoverComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzPopoverComponent,
        selectors: [["nz-popover"]],
        exportAs: ["nzPopoverComponent"],
        standalone: true,
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 6,
        consts: [["overlay", "cdkConnectedOverlay"], ["cdkConnectedOverlay", "", "nzConnectedOverlay", "", 3, "overlayOutsideClick", "detach", "positionChange", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPush", "nzArrowPointAtCenter"], [1, "ant-popover", 3, "ngClass", "ngStyle", "nzNoAnimation"], [1, "ant-popover-content"], [1, "ant-popover-arrow"], [1, "ant-popover-arrow-content"], ["role", "tooltip", 1, "ant-popover-inner"], [1, "ant-popover-title"], [1, "ant-popover-inner-content"], [4, "nzStringTemplateOutlet"]],
        template: function NzPopoverComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, NzPopoverComponent_ng_template_0_Template, 9, 9, "ng-template", 1, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵlistener("overlayOutsideClick", function NzPopoverComponent_Template_ng_template_overlayOutsideClick_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClickOutside($event));
            })("detach", function NzPopoverComponent_Template_ng_template_detach_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.hide());
            })("positionChange", function NzPopoverComponent_Template_ng_template_positionChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onPositionChange($event));
            });
          }
          if (rf & 2) {
            i0.ɵɵproperty("cdkConnectedOverlayHasBackdrop", ctx.hasBackdrop)("cdkConnectedOverlayOrigin", ctx.origin)("cdkConnectedOverlayPositions", ctx._positions)("cdkConnectedOverlayOpen", ctx._visible)("cdkConnectedOverlayPush", ctx.cdkConnectedOverlayPush)("nzArrowPointAtCenter", ctx.nzArrowPointAtCenter);
          }
        },
        dependencies: [OverlayModule, i1.CdkConnectedOverlay, NzOverlayModule, i2.NzConnectedOverlayDirective, NgClass, NgStyle, NzNoAnimationDirective, NzOutletModule, i3.NzStringTemplateOutletDirective],
        encapsulation: 2,
        data: {
          animation: [zoomBigMotion]
        },
        changeDetection: 0
      });
    }
  }
  return NzPopoverComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzPopoverModule = /*#__PURE__*/(() => {
  class NzPopoverModule {
    static {
      this.ɵfac = function NzPopoverModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzPopoverModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzPopoverModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [NzPopoverComponent]
      });
    }
  }
  return NzPopoverModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzPopoverComponent, NzPopoverDirective, NzPopoverModule };
